<div>
  <form [formGroup]="trackForm">
    <div class="track-edit-row">
      <div class="d-flex flex-col">
        Name
        <div class="custom-icon-input-container"  style="width: 200px">
          <input type="text" formControlName="title" placeholder="Name" style="p">
        </div>
<!--        <input matInput formControlName="title" class="admin-input-field"/>-->
      </div>

      <div class="d-flex flex-col">
        Artist
        <div class="custom-icon-input-container"  style="width: 200px">
          <input type="text" formControlName="artists" placeholder="Artists">
        </div>

      </div>


      <div>
        Genre
        <div class="admin-dropdown-input">
          <input type="text"
                 style="min-width: 170px; width: 170px"
                 placeholder="Pick one"
                 aria-label="Genre"
                 matInput
                 formControlName="genre"
                 [matAutocomplete]="genres">
          <mat-autocomplete #genres="matAutocomplete" [displayWith]="displayFn">
            @for (option of genreOptions; track option) {
              <mat-option [value]="option">{{option.name}}</mat-option>
            }
          </mat-autocomplete>

          @if (trackForm.value.genre) {
            <button matSuffix matIconButton aria-label="Clear" class="clear-icon" (click)="clearField('genre')">
              <mat-icon>cancel</mat-icon>
            </button>
          }
        </div>

      </div>


      <div>
        Sub Genre
        <div class="admin-dropdown-input">
          <input type="text"
                 style="min-width: 170px; width: 170px"
                 placeholder="Pick one"
                 aria-label="Sub Genre"
                 matInput
                 formControlName="subgenre"
                 [matAutocomplete]="subgenres">
          <mat-autocomplete #subgenres="matAutocomplete" [displayWith]="displayFn">
            @for (option of subgenreOptions; track option) {
              <mat-option [value]="option">{{option.name}}</mat-option>
            }
          </mat-autocomplete>
          @if (trackForm.value.subgenre) {
            <button matSuffix matIconButton aria-label="Clear" class="clear-icon" (click)="clearField('subgenre')">
              <mat-icon>cancel</mat-icon>
            </button>
          }
        </div>
      </div>






<!--    <div class="admin-input-select">-->
<!--      <mat-label>Artists</mat-label>-->
<!--      <mat-chip-grid #artistSelectorGrid aria-label="Artist selection">-->
<!--        @for (option of trackForm.value.artists; track option) {-->
<!--          <mat-chip-row (removed)="remove(option)">-->
<!--            {{option.name}}-->
<!--            <button matChipRemove [attr.aria-label]="'remove ' + option.id">-->
<!--              <mat-icon>cancel</mat-icon>-->
<!--            </button>-->
<!--          </mat-chip-row>-->
<!--        }-->
<!--      </mat-chip-grid>-->
<!--      <div class="select-input-field">-->
<!--        <input-->
<!--          placeholder="Select Artist"-->
<!--          #artistInput-->
<!--          formControlName="currentArtist"-->
<!--          [matChipInputFor]="artistSelectorGrid"-->
<!--          [matAutocomplete]="artistSelector"-->
<!--          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"-->
<!--        />-->
<!--        <mat-autocomplete #artistSelector="matAutocomplete" (optionSelected)="selected($event); artistInput.value = ''" [displayWith]="displayFn">-->
<!--          @for (option of artistOptions; track option) {-->
<!--            <mat-option [value]="option">{{option.name}}</mat-option>-->
<!--          }-->
<!--        </mat-autocomplete>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="track-edit-row justify-between">-->


<!--    <div class="track-edit-row justify-around">-->

<!--      <div>-->
<!--        Bpm-->
<!--        <div>-->
<!--          <input type="number" class="bpm-setter" formControlName="bpm" >-->
<!--          <mat-slider-->
<!--            [max]="200"-->
<!--            [min]="50"-->
<!--            [step]="1"-->
<!--            [discrete]="true"-->
<!--            [showTickMarks]="false">-->
<!--            <input matSliderThumb formControlName="bpm" #slider>-->
<!--          </mat-slider>-->
<!--        </div>-->

<!--      </div>-->
      <div class="d-flex flex-col">
        Bpm
        <div class="custom-icon-input-container" style="width: 50px">
          <input type="text" formControlName="bpm" placeholder="Artists">
        </div>

      </div>
      <div>
        Release Date
        <div class="admin-datepicker-input">


          <input matInput [matDatepicker]="picker" formControlName="releaseDate" style="min-width: 170px; width: 170px">
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker ></mat-datepicker>
        </div>
      </div>

    </div>
  </form>
</div>
